<template>
  <router-view />
</template>

<script setup>
// Auth is initialized in main.js before App mounts
</script>
